// import { useState, useEffect } from "react";
//Props Validations
import PropTypes from "prop-types";
// MUI components
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";
// redux
import { useSelector, useDispatch } from "react-redux";
import {
    loadOverallAbsoluteToggleState,
    loadSecondaryAbsoluteToggleState,
    loadAgreementAbsoluteToggleState,
    loadClaimsAbsoluteToggleState,
} from "store/features/analysisResultsSlice"

function AbsoluteCounts({ moduleName = "" }) {
    //REDUX
    const dispatch = useDispatch();

    // const analysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore[`${moduleName}AnalysisTypeValue`]);
    const absoluteToggle = useSelector((state) => state.analysisResultsStore[`${moduleName}AbsoluteToggle`]);

    // const [absoluteToggle, setAbsoluteToggle] = useState(currentAbsoluteToggle || false);
    // console.log("currentAbsoluteToggle",currentAbsoluteToggle,absoluteToggle)

    // useEffect(() => {
    //     setAbsoluteToggle(false);
    // }, [analysisTypeValue]);
    
    const handleAbsoluteToggleChange = () => {
        if (moduleName === "overall") {
            dispatch(loadOverallAbsoluteToggleState(!absoluteToggle));
        } else if (moduleName === "secondary") {
            dispatch(loadSecondaryAbsoluteToggleState(!absoluteToggle));
        } else if (moduleName === "agreement") {
            dispatch(loadAgreementAbsoluteToggleState(!absoluteToggle));
        } else if (moduleName === "claims") {
            dispatch(loadClaimsAbsoluteToggleState(!absoluteToggle));
        }
        // setAbsoluteToggle(!absoluteToggle);
    };

    return (
        <div
            style={{
                marginLeft: ".5rem",
                zIndex: "3",
                width: "200px",
            }}
        >
            <Button
                size="small"
                className="custom-btn custom-btn-outlined-2 color-blue bold-content ms-2 pb-1"
                variant="outlined"
            >
                Absolute Count
                <Switch
                    size="small"
                    checked={absoluteToggle}
                    onChange={handleAbsoluteToggleChange}
                />
            </Button>
        </div>
    )
}

AbsoluteCounts.propTypes = {
    moduleName: PropTypes.string,
};

export default AbsoluteCounts;